import {Injectable} from '@angular/core';
import {FieldTableDto} from '@tj/tj-dmp-lib-api';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class ValidatorEditorService {

    private EMAIL_REGEXP =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    constructor() {
    }

    public doValidateEmail(value: string): boolean {
        return this.EMAIL_REGEXP.test(value);
    }

    public doValidateTel(): boolean {
        return false;
    }

    public isNotBlank(value: string): boolean {
        return value !== null && value.trim().length > 0;
    }

    public isBlank(value: string): boolean {
        return !this.isNotBlank(value);
    }

    doValidate(field: FieldTableDto, value: any): boolean {
        let validate = true;
        switch (field.categoryField) {
            case 'EMAIL':
                if (field.notNull === true && (this.isBlank(value as string) || !this.doValidateEmail(value as string))) {
                    validate = false;
                } else if (field.notNull === false && this.isNotBlank(value as string) && !this.doValidateEmail(value as string)) {
                    validate = false;
                }
                break;
        }

        return validate;
    }

    doTransform(field: FieldTableDto, value: Date) {
        if (value === null) {
            return null;
        }
        let valueString = null;
        switch (field.categoryField) {
            case 'DATE':
                valueString = moment(value).format('YYYY-MM-DD');
                break;
            case 'DATE_TIME':
                valueString = moment(value).format('YYYY-MM-DD HH:mm:ss');
                break;
            case 'TIME':
                valueString = moment(value).format('HH:mm:ss');
                break;
        }
        return valueString || value;
    }

    getMaxLength(type: FieldTableDto.TypeEnum) {
        switch (type) {
            case 'String255':
                return 255;
            case 'String25':
                return 25;
            case 'String3':
                return 3;
            case 'String100' :
                return 100;
            case 'String10' :
                return 10;
            case 'String50' :
                return 50;
            case 'TEXT' :
                return 65535; // il faut bien mettre quelques chose
            case 'Int' :
                // -2147483648 à 2147483647
                return 11;
            case 'BigInt' :
                // -9223372036854775808 à 9223372036854775807
                return 20;
            case 'Decimal_5_2' :
                // 123,45
                return 6;
            case 'Decimal_8_2' :
                // 123456,78
                return 9;
            case 'Decimal_11_2' :
                // 123456789,01
                return 12;
            case 'Boolean' :
            case 'DateTime' :
            case 'Date' :
            case 'Time' :
            case 'UUID':
                return 0;
            default:
                return 0;
        }
    }

    getMinFractionDigits(type: FieldTableDto.TypeEnum) {
        switch (type) {
            case 'Decimal_5_2' :
            case 'Decimal_8_2' :
            case 'Decimal_11_2' :
                return 2;
            default:
                return 0;
        }
    }
}
